import { apiClient } from "./apiClient";
import { FO_BAOCAO_AN_HOC_SINH_API_END_POINT } from "./foDangKyAnHocSinhApi";

export const FO_DIEM_DANH_AN_API_END_POINT = "food/diem-danh-an";

export interface IFoDiemDanhAn {
  id: number;
  ngay_an: string | null;
  fo_caan_id: number;
  ts_hocsinh_id: number;
  gio_diem_danh: string | null;
  nam_hoc: string;
  image_url: string;
  ghi_chu: string;
  app_notify_id: number;
  is_synced: boolean;
}

export interface IDiemDanhAnItemResponse extends IFoDiemDanhAn {
  ma_hs: string;
  ho_ten: string;
  ten_truong: string;
  ten_he: string;
  ten_khoi: string;
  ten_lop: string;
  combo_dang_ky: string;
  dm_truong_id: number;
  dm_khoi_id: number;
  dm_he_id: number;
  dm_lop_id: number;
  ngay_sinh: string;
  ca_an: string;
  order_idx: number;
  gio_bat_dau_an: string;
  gio_ket_thuc_an: string;
  is_dang_ky_an: boolean;

}

export interface IDiemDanhAnRequest {
  ts_hocsinh_id: number;
  ngay_an: string;
  fo_caan_id: number;
  gio_diem_danh: string;
  nam_hoc: string;
  ghi_chu?: string;
  image_url?: string;
}

export interface ILogSelectRequest {
  tu_ngay: string;
  den_ngay: string;
  nam_hoc: string;
  dm_coso_id: number;
  dm_truong_id: number;
  ma_hs: string;
}

export const foDiemDanhAnApi = {
  selectAll: () => apiClient.get(FO_DIEM_DANH_AN_API_END_POINT),

  selectById: (id: number) =>
    apiClient.get(`${FO_DIEM_DANH_AN_API_END_POINT}/${id}`),

  selectByNgayAnRange: (request: ILogSelectRequest) =>
    apiClient.post(`${FO_DIEM_DANH_AN_API_END_POINT}/view`, request),

  selectByNgayAn: (ngay_an: string, nam_hoc: string, dm_coso_id: number) =>
    apiClient.get(`${FO_DIEM_DANH_AN_API_END_POINT}/ngay-an/${encodeURIComponent(ngay_an)}/nam-hoc/${nam_hoc}/co-so/${dm_coso_id}`),

    selectBaoCaoDiemDanh: (ngay_an: string, nam_hoc: string, dm_coso_id: number) =>
    apiClient.get(`${FO_BAOCAO_AN_HOC_SINH_API_END_POINT}/diem-danh-an/ngay-an/${encodeURIComponent(ngay_an)}/nam-hoc/${nam_hoc}/co-so/${dm_coso_id}`),

  insert: (data: IFoDiemDanhAn) =>
    apiClient.post(FO_DIEM_DANH_AN_API_END_POINT, data),

  update: (data: IFoDiemDanhAn) =>
    apiClient.put(FO_DIEM_DANH_AN_API_END_POINT, data),

  diemDanh: (data: IDiemDanhAnRequest) =>
    apiClient.post(`${FO_DIEM_DANH_AN_API_END_POINT}/diem-danh`, data),

  delete: (id: number) =>
    apiClient.delete(`${FO_DIEM_DANH_AN_API_END_POINT}/${id}`),

  huyDiemDanh: (id: number) =>
    apiClient.post(`${FO_DIEM_DANH_AN_API_END_POINT}/huy-diem-danh/${id}`),

  saveChanges: (data: { diemDanhAns: IFoDiemDanhAn[] }) =>
    apiClient.post(`${FO_DIEM_DANH_AN_API_END_POINT}/savechanges`, data)
};
